import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvitationsService } from '../../modules/vms/invitations/invitations.service';

@Component({
    selector: 'app-invitation-resolver',
    templateUrl: './invitation-resolver.component.html',
    styleUrls: ['./invitation-resolver.component.scss'],
    standalone: false
})
export class InvitationResolverComponent implements OnInit {
  loading = true;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invitationsService: InvitationsService
  ) { }

  ngOnInit(): void {
    const code = this.route.snapshot.paramMap.get('code');
    
    if (code) {
      this.resolveInvitationCode(code);
    } else {
      this.loading = false;
      this.error = 'Invalid invitation code';
    }
  }

  resolveInvitationCode(code: string): void {
    this.invitationsService.resolveInvitationCode(code).subscribe({
      next: (response) => {
        if (response && response.redirectUrl) {
          // Redirect to the URL provided in the response
          window.location.href = response.redirectUrl;
        } else {
          this.loading = false;
          this.error = 'Invalid invitation or no redirect URL found';
        }
      },
      error: (err) => {
        console.error('Error resolving invitation code:', err);
        this.loading = false;
        this.error = 'Failed to resolve invitation code. Please check if the code is valid.';
      }
    });
  }
}